/* ==========================================================================
   EMPIRE HOLLYWOOD — LUXE ENHANCE v6 : HOME STORY BLOCKS (eh-home-blocks.js)
   Self-injecting asset. On the HOMEPAGE, inserts — directly UNDER the BOTTOM-most
   slideshow section (owner spec) — three brand blocks:
     (2) Custom-jewelry CTA + a 3D COVERFLOW of past custom work  →  Google Form
     (1) 店舗一覧 : store cards, each linking to Google Maps
     (3) Owned-media button  →  moissanite pillar article
   ADDITIVE / self-contained (own <style>) / no theme file edits. Fails silently.
   Brand base #385C60. Distinct from the poster marquee & ranking rail so nothing
   visually clashes.
   ========================================================================== */
(function(){
  if(window.__ehHomeBlocks) return; window.__ehHomeBlocks = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CDN = 'https://cdn.shopify.com/s/files/1/0886/1984/3887/files/';

  /* ---- data ------------------------------------------------------------- */
  var LINE_URL  = 'https://lin.ee/N2Ynexi';
  var MEDIA_URL = 'https://empire-media-blog.com/what-is-moissanite/';

  var CUSTOM = [];
  for(var ci=1; ci<=12; ci++){ CUSTOM.push(CDN + 'eh-custom-' + ci + '.jpg?width=680'); }

  var STORES = [
    {name:'大阪店',        en:'OSAKA',   img:CDN+'eh-store-osaka.jpg?width=900',   map:'https://share.google/KbYWobMTOiEjgpGMo'},
    {name:'名古屋店',      en:'NAGOYA',  img:CDN+'eh-store-nagoya.jpg?width=900',  map:'https://share.google/Xg6I3waRSjkztB0zA'},
    {name:'札幌（北広島）店', en:'SAPPORO', img:CDN+'eh-store-sapporo.jpg?width=900', map:'https://share.google/8DiCH30cfUbwIEP3x'},
    {name:'十勝本店',      en:'TOKACHI', img:CDN+'eh-store-tokachi.jpg?width=900', map:'https://share.google/Kj4Cbb4z2KPEUMzdK'}
  ];

  /* ---- styles (self-contained) ----------------------------------------- */
  var CSS = ''
  + '.ehhb{--b:#385C60;--bd:#233b3e;--bdp:#16292b;--bl:#7fb0b5;--gd:#c8a45c;--gd2:#ecd49a;'
  + 'font-family:inherit;box-sizing:border-box;width:100%;overflow:hidden;}'
  + '.ehhb *,.ehhb *::before,.ehhb *::after{box-sizing:border-box;}'
  + '.ehhb-reveal{opacity:0;transform:translateY(40px);transition:opacity 1s cubic-bezier(.16,1,.3,1),transform 1s cubic-bezier(.16,1,.3,1);}'
  + '.ehhb-reveal.is-in{opacity:1;transform:none;}'
  + '.ehhb-eyebrow{margin:0 0 10px;font-size:11px;letter-spacing:.34em;text-transform:uppercase;color:var(--b);font-weight:700;}'
  + '.ehhb-h2{margin:0;font-size:clamp(23px,3.6vw,38px);font-weight:800;letter-spacing:.02em;line-height:1.2;color:#16292b;}'
  + '.ehhb-lead{margin:12px auto 0;max-width:620px;font-size:14px;line-height:1.85;color:#5b6b6c;}'
  /* ---- custom jewelry (dark showcase + coverflow) ---- */
  + '.ehcj{position:relative;margin:0;padding:clamp(44px,6vw,78px) 16px clamp(40px,5vw,64px);text-align:center;overflow:hidden;'
  + 'background:radial-gradient(120% 140% at 50% 0%,#3f6a6f 0%,#2c4a4d 42%,#16292b 100%);}'
  + '.ehcj::before{content:"";position:absolute;inset:0;pointer-events:none;opacity:.5;'
  + 'background:radial-gradient(60% 55% at 50% 42%,rgba(234,247,248,.10),transparent 70%);}'
  + '.ehcj__head{position:relative;z-index:2;max-width:720px;margin:0 auto;}'
  + '.ehcj .ehhb-eyebrow{color:var(--gd2);}'
  + '.ehcj__title{margin:0;font-size:clamp(24px,4.2vw,42px);font-weight:800;line-height:1.24;color:#fff;letter-spacing:.02em;text-shadow:0 2px 20px rgba(0,0,0,.35);}'
  + '.ehcj__title span{background:linear-gradient(100deg,#ecd49a,#fff,#b9d7da,#ecd49a);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;}'
  + '.ehcj__sub{margin:14px auto 0;max-width:560px;font-size:14px;line-height:1.85;color:rgba(230,240,240,.82);}'
  + '.ehcj__stage{position:relative;z-index:2;height:clamp(330px,52vw,470px);margin:clamp(26px,4vw,40px) auto 0;max-width:1180px;'
  + 'perspective:1500px;display:flex;align-items:center;justify-content:center;}'
  + '.ehcj__viewport{position:relative;width:100%;height:100%;transform-style:preserve-3d;}'
  + '.ehcj__track{position:absolute;inset:0;transform-style:preserve-3d;}'
  + '.ehcj__card{position:absolute;left:50%;top:50%;width:clamp(210px,26vw,290px);height:clamp(280px,35vw,388px);margin:0;'
  + 'transform:translate(-50%,-50%);transform-style:preserve-3d;cursor:pointer;border-radius:16px;overflow:hidden;'
  + 'background:#0e1c1d;box-shadow:0 30px 60px -22px rgba(0,0,0,.7);will-change:transform,opacity;'
  + 'transition:transform .6s cubic-bezier(.16,1,.3,1),opacity .6s cubic-bezier(.16,1,.3,1);}'
  + '.ehcj__card img{width:100%;height:100%;object-fit:cover;display:block;pointer-events:none;}'
  + '.ehcj__card::after{content:"";position:absolute;inset:0;border-radius:16px;pointer-events:none;'
  + 'box-shadow:inset 0 0 0 1px rgba(236,212,154,.28);background:linear-gradient(180deg,transparent 55%,rgba(11,22,23,.55));}'
  + '.ehcj__card.is-active{box-shadow:0 40px 80px -20px rgba(0,0,0,.8),0 0 0 1px rgba(236,212,154,.5),0 0 40px rgba(127,176,181,.35);}'
  + '.ehcj__badge{position:absolute;left:12px;bottom:12px;z-index:3;font-size:9.5px;letter-spacing:.22em;font-weight:700;'
  + 'color:#eaf7f8;text-transform:uppercase;padding:5px 9px;border-radius:100px;background:rgba(22,41,43,.5);'
  + 'backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px);border:1px solid rgba(236,212,154,.35);}'
  + '.ehcj__nav{position:absolute;top:50%;transform:translateY(-50%);z-index:6;width:46px;height:46px;border-radius:50%;'
  + 'border:1px solid rgba(236,212,154,.4);background:rgba(22,41,43,.42);color:#fff;font-size:24px;line-height:1;cursor:pointer;'
  + 'backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);transition:background .3s,transform .3s,border-color .3s;'
  + 'display:flex;align-items:center;justify-content:center;padding-bottom:3px;}'
  + '.ehcj__nav--prev{left:max(8px,calc(50% - 560px));}.ehcj__nav--next{right:max(8px,calc(50% - 560px));}'
  + '.ehcj__nav:hover{background:var(--gd);border-color:var(--gd);color:#16292b;transform:translateY(-50%) scale(1.08);}'
  + '.ehcj__dots{position:relative;z-index:2;display:flex;gap:8px;justify-content:center;margin:clamp(22px,3vw,30px) 0 0;}'
  + '.ehcj__dot{width:7px;height:7px;border-radius:50%;border:0;padding:0;background:rgba(234,247,248,.32);cursor:pointer;transition:all .3s;}'
  + '.ehcj__dot.is-active{background:var(--gd2);width:22px;border-radius:4px;}'
  + '.ehcj__ctawrap{position:relative;z-index:2;margin:clamp(26px,3.6vw,36px) 0 0;}'
  + '.ehcj__cta{display:inline-flex;align-items:center;gap:12px;padding:16px 34px;border-radius:100px;text-decoration:none;'
  + 'font-size:15px;font-weight:800;letter-spacing:.05em;color:#16292b;position:relative;overflow:hidden;'
  + 'background:linear-gradient(100deg,#ecd49a,#c8a45c 55%,#ecd49a);box-shadow:0 16px 34px -12px rgba(200,164,92,.7);'
  + 'transition:transform .3s cubic-bezier(.16,1,.3,1),box-shadow .3s;}'
  + '.ehcj__cta .ehcj__cta-ic{transition:transform .35s cubic-bezier(.16,1,.3,1);}'
  + '.ehcj__cta:hover{transform:translateY(-3px);box-shadow:0 22px 44px -12px rgba(200,164,92,.85);}'
  + '.ehcj__cta:hover .ehcj__cta-ic{transform:translateX(5px);}'
  + '.ehcj__cta::before{content:"";position:absolute;top:0;left:-60%;width:40%;height:100%;transform:skewX(-20deg);'
  + 'background:linear-gradient(90deg,transparent,rgba(255,255,255,.65),transparent);animation:ehcjShine 4.5s ease-in-out infinite;}'
  + '@keyframes ehcjShine{0%,72%{left:-60%;}86%,100%{left:130%;}}'
  /* ---- store list ---- */
  + '.ehhb-stores{padding:clamp(52px,6.5vw,86px) clamp(14px,4vw,60px) clamp(40px,5vw,60px);text-align:center;background:#fff;}'
  + '.ehhb-store-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:clamp(12px,1.6vw,22px);max-width:1180px;margin:clamp(28px,4vw,44px) auto 0;}'
  + '.ehhb-store{position:relative;display:block;text-decoration:none;border-radius:16px;overflow:hidden;background:#0e1c1d;'
  + 'box-shadow:0 18px 40px -24px rgba(22,41,43,.6);transition:transform .5s cubic-bezier(.16,1,.3,1),box-shadow .5s;}'
  + '.ehhb-store__img{position:relative;aspect-ratio:3/4;overflow:hidden;}'
  + '.ehhb-store__img img{width:100%;height:100%;object-fit:cover;display:block;transition:transform 1.1s cubic-bezier(.16,1,.3,1);}'
  + '.ehhb-store__img::after{content:"";position:absolute;inset:0;background:linear-gradient(180deg,transparent 38%,rgba(9,20,21,.28) 62%,rgba(9,20,21,.9));}'
  + '.ehhb-store__body{position:absolute;left:0;right:0;bottom:0;z-index:2;padding:16px 16px 18px;text-align:left;color:#fff;}'
  + '.ehhb-store__en{display:block;font-size:10px;letter-spacing:.3em;font-weight:700;color:var(--gd2);margin:0 0 3px;}'
  + '.ehhb-store__name{display:block;font-size:clamp(16px,1.5vw,19px);font-weight:800;letter-spacing:.02em;}'
  + '.ehhb-store__btn{display:inline-flex;align-items:center;gap:6px;margin-top:9px;font-size:11.5px;font-weight:700;letter-spacing:.04em;'
  + 'color:#eaf7f8;padding:6px 13px;border-radius:100px;border:1px solid rgba(236,212,154,.5);background:rgba(22,41,43,.35);'
  + 'backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px);transition:background .3s,color .3s,border-color .3s;}'
  + '.ehhb-store__btn svg{width:12px;height:12px;fill:currentColor;}'
  + '@media (hover:hover){.ehhb-store:hover{transform:translateY(-7px);box-shadow:0 30px 60px -26px rgba(22,41,43,.7);}'
  + '.ehhb-store:hover .ehhb-store__img img{transform:scale(1.08);}'
  + '.ehhb-store:hover .ehhb-store__btn{background:var(--gd);color:#16292b;border-color:var(--gd);}}'
  + '@media (max-width:860px){.ehhb-store-grid{grid-template-columns:repeat(2,1fr);}}'
  /* ---- owned media ---- */
  + '.ehhb-media-wrap{padding:clamp(30px,4vw,52px) clamp(14px,4vw,60px) clamp(58px,7vw,92px);background:#fff;}'
  + '.ehhb-media{position:relative;display:flex;align-items:center;gap:clamp(16px,3vw,40px);max-width:1180px;margin:0 auto;'
  + 'padding:clamp(24px,3.4vw,40px) clamp(22px,3.6vw,48px);border-radius:20px;text-decoration:none;overflow:hidden;isolation:isolate;'
  + 'background:linear-gradient(105deg,#16292b 0%,#233b3e 46%,#385C60 100%);box-shadow:0 26px 60px -30px rgba(22,41,43,.8);}'
  + '.ehhb-media::before{content:"";position:absolute;inset:0;z-index:0;pointer-events:none;opacity:.55;'
  + 'background:radial-gradient(40% 120% at 88% 50%,rgba(127,176,181,.4),transparent 70%);}'
  + '.ehhb-media::after{content:"✦";position:absolute;z-index:0;right:clamp(80px,16vw,220px);top:50%;transform:translateY(-50%);'
  + 'font-size:clamp(120px,20vw,240px);line-height:1;color:rgba(236,212,154,.10);pointer-events:none;}'
  + '.ehhb-media__txt{position:relative;z-index:2;flex:1;text-align:left;min-width:0;}'
  + '.ehhb-media .ehhb-eyebrow{color:var(--gd2);}'
  + '.ehhb-media__title{margin:0;font-size:clamp(18px,2.5vw,27px);font-weight:800;line-height:1.35;color:#fff;letter-spacing:.01em;}'
  + '.ehhb-media__sub{margin:9px 0 0;font-size:13px;line-height:1.7;color:rgba(225,238,238,.78);}'
  + '.ehhb-media__btn{position:relative;z-index:2;flex:none;display:inline-flex;align-items:center;gap:9px;white-space:nowrap;'
  + 'padding:14px 26px;border-radius:100px;font-size:14px;font-weight:800;letter-spacing:.04em;color:#16292b;'
  + 'background:linear-gradient(100deg,#ecd49a,#c8a45c 60%,#ecd49a);box-shadow:0 12px 28px -10px rgba(200,164,92,.6);'
  + 'transition:transform .3s cubic-bezier(.16,1,.3,1),box-shadow .3s;}'
  + '.ehhb-media__btn span{transition:transform .35s cubic-bezier(.16,1,.3,1);}'
  + '@media (hover:hover){.ehhb-media:hover .ehhb-media__btn{transform:translateY(-2px);box-shadow:0 18px 36px -10px rgba(200,164,92,.75);}'
  + '.ehhb-media:hover .ehhb-media__btn span{transform:translateX(5px);}}'
  + '@media (max-width:680px){.ehhb-media{flex-direction:column;text-align:center;align-items:stretch;}'
  + '.ehhb-media__txt{text-align:center;}.ehhb-media__btn{justify-content:center;}}'
  + '@media (prefers-reduced-motion:reduce){.ehhb-reveal{opacity:1!important;transform:none!important;transition:none!important;}'
  + '.ehcj__cta::before{animation:none;display:none;}.ehcj__card{transition:none;}}';

  /* ---- build markup ----------------------------------------------------- */
  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  var mapIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z"/></svg>';

  var cardsHtml = '';
  CUSTOM.forEach(function(u,i){
    cardsHtml += '<div class="ehcj__card" data-i="'+i+'"><img src="'+u+'" alt="EMPIRE HOLLYWOOD カスタムジュエリー制作実績 '+(i+1)+'" loading="lazy"><span class="ehcj__badge">Empire Custom</span></div>';
  });

  var storesHtml = '';
  STORES.forEach(function(s){
    storesHtml += '<a class="ehhb-store" href="'+esc(s.map)+'" target="_blank" rel="noopener noreferrer" aria-label="'+esc(s.name)+' をGoogle Mapで見る">'
      + '<div class="ehhb-store__img"><img src="'+s.img+'" alt="EMPIRE HOLLYWOOD '+esc(s.name)+' 店内" loading="lazy"></div>'
      + '<div class="ehhb-store__body"><span class="ehhb-store__en">'+esc(s.en)+'</span><span class="ehhb-store__name">'+esc(s.name)+'</span>'
      + '<span class="ehhb-store__btn">'+mapIcon+'Google Mapで見る</span></div></a>';
  });

  var html = ''
  + '<section class="ehcj ehhb-reveal" aria-label="カスタムジュエリー">'
  +   '<div class="ehcj__head"><p class="ehhb-eyebrow">CUSTOM ORDER</p>'
  +     '<h2 class="ehcj__title">世界に一つだけの<br><span>オリジナルジュエリー</span></h2>'
  +     '<p class="ehcj__sub">あなたの想いを、熟練の職人が唯一無二のピースへ。これまでの制作実績をご覧ください。</p></div>'
  +   '<div class="ehcj__stage" data-cf>'
  +     '<button class="ehcj__nav ehcj__nav--prev" type="button" aria-label="前へ">&#8249;</button>'
  +     '<div class="ehcj__viewport" data-cf-vp><div class="ehcj__track" data-cf-track>'+cardsHtml+'</div></div>'
  +     '<button class="ehcj__nav ehcj__nav--next" type="button" aria-label="次へ">&#8250;</button>'
  +   '</div>'
  +   '<div class="ehcj__dots" data-cf-dots></div>'
  +   '<div class="ehcj__ctawrap"><a class="ehcj__cta" href="'+esc(LINE_URL)+'" target="_blank" rel="noopener noreferrer">無料で相談する<span class="ehcj__cta-ic">&#8594;</span></a></div>'
  + '</section>'
  + '<section class="ehhb-stores ehhb-reveal" aria-label="店舗一覧">'
  +   '<p class="ehhb-eyebrow">STORES</p><h2 class="ehhb-h2">店舗一覧</h2>'
  +   '<p class="ehhb-lead">全国のEMPIRE HOLLYWOODで、その輝きを直接お確かめください。各店舗をタップするとGoogle Mapが開きます。</p>'
  +   '<div class="ehhb-store-grid">'+storesHtml+'</div>'
  + '</section>'
  + '<section class="ehhb-media-wrap ehhb-reveal" aria-label="モアサナイト ジャーナル">'
  +   '<a class="ehhb-media" href="'+esc(MEDIA_URL)+'" target="_blank" rel="noopener noreferrer">'
  +     '<div class="ehhb-media__txt"><p class="ehhb-eyebrow">MOISSANITE JOURNAL</p>'
  +       '<h3 class="ehhb-media__title">モアサナイトのすべてを、宝石のプロが解説。</h3>'
  +       '<p class="ehhb-media__sub">ダイヤモンドとの違い、後悔しない選び方。読めば、きっと欲しくなる。</p></div>'
  +     '<span class="ehhb-media__btn">記事を読む<span>&#8594;</span></span>'
  +   '</a>'
  + '</section>';

  /* ---- coverflow engine ------------------------------------------------- */
  function initCoverflow(root){
    var track = root.querySelector('[data-cf-track]');
    var vp    = root.querySelector('[data-cf-vp]');
    var cards = [].slice.call(root.querySelectorAll('.ehcj__card'));
    var dotsWrap = root.parentNode.querySelector('[data-cf-dots]');
    var n = cards.length; if(!n) return;
    var active = 0, timer = null, DUR = 3200;

    /* dots */
    var dots = [];
    if(dotsWrap){
      for(var d=0; d<n; d++){
        var b = document.createElement('button');
        b.type='button'; b.className='ehcj__dot'; b.setAttribute('aria-label',(d+1)+'枚目');
        (function(idx){ b.addEventListener('click', function(){ to(idx); bump(); }); })(d);
        dotsWrap.appendChild(b); dots.push(b);
      }
    }
    function mob(){ return window.matchMedia('(max-width:768px)').matches; }
    function cfg(){ return mob()
      ? {sp:132,dz:150,ang:32,sc:0.20,op:0.34,range:2}
      : {sp:236,dz:230,ang:36,sc:0.15,op:0.24,range:3}; }
    function wrap(x){ x=x%n; if(x>n/2) x-=n; if(x<-n/2) x+=n; return x; }
    function render(){
      var c = cfg();
      for(var i=0;i<n;i++){
        var p = wrap(i-active), ap = Math.abs(p), card = cards[i];
        if(ap > c.range){
          card.style.opacity='0'; card.style.pointerEvents='none'; card.style.zIndex='0';
          card.style.transform='translate(-50%,-50%) translateX('+((p>0?1:-1)*(c.range+1)*c.sp)+'px) translateZ(-'+((c.range+1)*c.dz)+'px) scale(.4)';
          card.classList.remove('is-active'); continue;
        }
        var tx=p*c.sp, tz=-ap*c.dz, ry=-p*c.ang, sc=Math.max(1-ap*c.sc,.5), op=Math.max(1-ap*c.op,0);
        card.style.transform='translate(-50%,-50%) translateX('+tx+'px) translateZ('+tz+'px) rotateY('+ry+'deg) scale('+sc+')';
        card.style.opacity=String(op); card.style.zIndex=String(100-ap); card.style.pointerEvents='auto';
        card.classList.toggle('is-active', p===0);
      }
      for(var k=0;k<dots.length;k++){ dots[k].classList.toggle('is-active', k===active); }
    }
    function go(dir){ active=(active+dir+n)%n; render(); }
    function to(i){ active=((i%n)+n)%n; render(); }
    function start(){ if(reduce) return; stop(); timer=setInterval(function(){ go(1); }, DUR); }
    function stop(){ if(timer){ clearInterval(timer); timer=null; } }
    function bump(){ start(); }

    cards.forEach(function(card,i){ card.addEventListener('click', function(){ if(root.__sw) return; to(i); bump(); }); });
    var prev=root.querySelector('.ehcj__nav--prev'), next=root.querySelector('.ehcj__nav--next');
    if(prev) prev.addEventListener('click', function(){ go(-1); bump(); });
    if(next) next.addEventListener('click', function(){ go(1); bump(); });

    /* swipe (touch) */
    var sx=0;
    vp.addEventListener('touchstart', function(e){ sx=e.touches[0].clientX; root.__sw=false; stop(); }, {passive:true});
    vp.addEventListener('touchend', function(e){ var dx=e.changedTouches[0].clientX-sx;
      if(Math.abs(dx)>40){ root.__sw=true; go(dx<0?1:-1); setTimeout(function(){ root.__sw=false; },60); } bump(); });
    /* drag (mouse) */
    var md=false, mx=0;
    vp.addEventListener('mousedown', function(e){ md=true; mx=e.clientX; root.__sw=false; stop(); });
    window.addEventListener('mouseup', function(e){ if(!md) return; md=false; var dx=e.clientX-mx;
      if(Math.abs(dx)>50){ root.__sw=true; go(dx<0?1:-1); setTimeout(function(){ root.__sw=false; },60); } bump(); });
    /* pause on hover */
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start);

    var rt; window.addEventListener('resize', function(){ clearTimeout(rt); rt=setTimeout(render,150); });
    render(); start();
  }

  /* ---- inject ----------------------------------------------------------- */
  function ready(fn){ if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  ready(function(){
    try{
      if(!document.body.classList.contains('template-index')) return;
      if(document.querySelector('[data-ehhb]')) return;

      var st = document.createElement('style'); st.id='eh-home-blocks-css'; st.textContent=CSS; document.head.appendChild(st);

      var wrap = document.createElement('div'); wrap.className='ehhb'; wrap.setAttribute('data-ehhb',''); wrap.innerHTML=html;

      /* place the blocks directly UNDER the bottom-most slideshow (owner spec) */
      var slides = document.querySelectorAll('[id^="shopify-section-slideshow"]');
      var anchor = (slides.length ? slides[slides.length - 1] : null)
                || document.getElementById('shopify-section-slideshow_rqLLaV')
                || document.getElementById('shopify-section-intro_cz9hYY');
      if(anchor && anchor.parentNode){ anchor.insertAdjacentElement('afterend', wrap); }
      else {
        var main = document.querySelector('.main-content') || document.querySelector('main') || document.body;
        main.appendChild(wrap);
      }

      /* (#4) keep the お問い合わせ / SNS widget as the very last content, below
         these blocks (owner). Move the policy section to sit just after the
         mission-intro / just before the footer. */
      try{
        var policy = document.getElementById('shopify-section-featured_policy_az7kca');
        if(policy){
          var intro  = document.getElementById('shopify-section-intro_cz9hYY');
          var footer = document.getElementById('shopify-section-footer');
          if(intro && intro.parentNode){ intro.insertAdjacentElement('afterend', policy); }
          else if(footer && footer.parentNode){ footer.parentNode.insertBefore(policy, footer); }
          else { wrap.insertAdjacentElement('afterend', policy); }
        }
      }catch(e){}

      /* make the 2BUY1FREE banner clickable → its rules page (owner) */
      try{
        var banner = document.getElementById('shopify-section-featured_background_image_tdkNxy');
        if(banner && !banner.querySelector('.ehbanner-link')){
          if(getComputedStyle(banner).position === 'static'){ banner.style.position = 'relative'; }
          banner.style.cursor = 'pointer';
          var bl = document.createElement('a');
          bl.className = 'ehbanner-link';
          bl.href = '/pages/2buy1free%E3%81%A8%E3%81%AF';
          bl.setAttribute('aria-label', '2BUY1FREE のルールを見る');
          bl.style.cssText = 'position:absolute;inset:0;z-index:5;display:block;';
          banner.appendChild(bl);
        }
      }catch(e){}

      initCoverflow(wrap.querySelector('[data-cf]'));

      /* reveal on scroll */
      if(!reduce && 'IntersectionObserver' in window){
        var io = new IntersectionObserver(function(ents){
          ents.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
        }, {threshold:0.12});
        [].forEach.call(wrap.querySelectorAll('.ehhb-reveal'), function(el){ io.observe(el); });
      } else {
        [].forEach.call(wrap.querySelectorAll('.ehhb-reveal'), function(el){ el.classList.add('is-in'); });
      }
    }catch(e){}
  });
})();
